import { useEffect, useState } from "react";
import Button from "../components/Button";
import { useConfigContext } from "../providers/ConfigProvider";
import { useNewReportContext } from "../providers/NewReportProvider";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import FullscreenLoader from "../components/FullscreenLoader";
import { AnimatePresence, motion } from "framer-motion";
import { ReportItem } from "./ApplicationReports";
import { useTranslation } from "react-i18next";

const Report = () => {
    const { t } = useTranslation();
    const { reportDraftId, skipDraftChoice, disableIllustrations } = useConfigContext();
    const { report, reportType, reportId, draftIds, setReportData, next, getDraftFromDataBase, contextDone, applicationId, reportStatus, deleteDraftFromDataBase } = useNewReportContext();
    const [isLoading, setLoading] = useState(false);
    const [isNewLoading, setNewLoading] = useState(false);
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        if (!report) {
            setReportData(params.formType ?? '', parseInt(params.id ?? ''));
        }
    })

    const handleNewReport = () => {
        deleteDraftFromDataBase(reportType, reportDraftId);
    }

    const handleContinueReport = () => {
        getDraftFromDataBase().then((url) => {
            if (url) {
                navigate(url);
            } else {
                next();
            }
        })
    }

    if (report === null || !contextDone) {
        return <FullscreenLoader />
    }

    if (reportDraftId && reportId === null && !draftIds) {
        if (skipDraftChoice || reportStatus === 0) {
            handleContinueReport();
            return "";
        } else {
            return (
                <AnimatePresence mode="wait">
                    <motion.div
                        key="draft-choice"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="container d-flex flex-column align-items-center justify-content-center h-100"
                    >
                        <div className="row justify-content-center w-100">
                            <div className="col-md-10 col-lg-8 col-xl-6 text-center">
                                <div className="display-5 mb-5">{t('welcome_back')}</div>
                                {!disableIllustrations && <img src="/svg/intro.svg" alt="" />}
                                <p className="mt-5 mb-4">{t('welcome_back_text_report')}</p>
                                <div className="d-flex justify-content-center mt-4 flex-column flex-md-row gap-3">
                                    <Button
                                        title={t('close_and_start_over')}
                                        type="outline-primary"
                                        onClick={() => { setNewLoading(true); handleNewReport() }}
                                        loading={isNewLoading}
                                    />
                                    <Button
                                        title={t('report_continue')}
                                        type="primary"
                                        rightIcon="arrow-right"
                                        onClick={() => { setLoading(true); handleContinueReport() }}
                                        loading={isLoading}
                                    />
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </AnimatePresence>
            )
        }
    }

    if (reportId === null && draftIds) {
        if (skipDraftChoice) {
            handleContinueReport();
            return "";
        }
        return (
            <AnimatePresence mode="wait">
                <motion.div
                    key="draft-choice"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="container d-flex flex-column align-items-center justify-content-center h-100"
                >
                    <div className="row justify-content-center w-100">
                        <div className="col-md-10 col-lg-8 col-xl-6 text-center">
                            <div className="display-5 mb-5">{t('welcome_back')}</div>
                            {!disableIllustrations && <img src="/svg/intro.svg" alt="" />}
                            <p className="mt-5 mb-4">{t('welcome_back_text_multiple')}</p>

                            {draftIds.map((draft, index) => (
                                <ReportItem key={index} {...draft} />
                            ))}

                            <div className="text-center">
                                <Button
                                    title={t('back')}
                                    type="linkbtn"
                                    leftIcon="arrow-left"
                                    onClick={() => navigate(-1)}
                                />
                            </div>
                        </div>
                    </div>
                </motion.div>
            </AnimatePresence>
        )
    }

    if (params.section) {
        return (
            <Outlet />
        );
    }

    if (!params.section && !reportDraftId) {
        //next();
    }

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key="draft-choice"
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="container d-flex flex-column align-items-center justify-content-center h-100"
            >
                <div className="row justify-content-center w-100">
                    <div className="col-md-10 col-lg-8 col-xl-6 text-center">
                        <div className="display-5 mb-5">
                            Lever {report.title.toLowerCase()}
                        </div>
                        {!disableIllustrations && (
                            <img src={import.meta.env.BASE_URL + 'svg/intro.svg'} className='mb-4' alt="" />
                        )}
                        <p className="mt-5 mb-4">
                            {report.introtext}
                        </p>

                        <div className="text-center my-3">
                            <Button
                                title="Sett i gang"
                                type="primary"
                                rightIcon="arrow-right"
                                onClick={next}
                            />
                        </div>
                        <div className="text-center">
                            <Button
                                title={t('back')}
                                type="linkbtn"
                                leftIcon="arrow-left"
                                onClick={() => navigate(-1)}
                            />
                        </div>
                    </div>
                </div>
            </motion.div>
        </AnimatePresence>
    );
}

export default Report;